import { EHeadingStyleVariant, Heading, Text } from '@outdoorsyco/bonfire';
import { FormattedMessage } from 'react-intl';

export const Headline = () => {
  return (
    <div>
      <Text className="pt-10 uppercase">
        <FormattedMessage defaultMessage="ALL-IN-ONE-BOOKINGS" id="vcojdt" />
      </Text>
      <Heading
        variant={EHeadingStyleVariant.H1Alt}
        className="flex mt-4 not-italic font-normal break-words text-[32px] lg:text-[64px]">
        <FormattedMessage
          defaultMessage="RV delivery to{br}resort destinations."
          id="vk3k1e"
          values={{
            br: <br />,
          }}
        />
      </Heading>
    </div>
  );
};
